export const getHeaderOffset = () => {
  const header = document.querySelector(".header");
  return header ? Math.ceil(header.getBoundingClientRect().height) + 8 : 88;
};

export const scrollToAnchor = (sectionId, attempts = 0) => {
  const el = document.getElementById(sectionId);
  if (!el) {
    if (attempts < 30) {
      window.setTimeout(() => scrollToAnchor(sectionId, attempts + 1), 50);
    }
    return;
  }

  const top = el.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
  window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
};
